export const STORE_USER: string = 'STORE_USER';
export const USER_SIGNED_OUT: string = 'USER_SIGNED_OUT';
export const USER_EXPIRED: string = 'USER_EXPIRED';
export const STORE_USER_ERROR: string = 'STORE_USER_ERROR';
export const LOADING_USER: string = 'LOADING_USER';
